import { lighten } from 'polished';
import styled from 'styled-components';

export const Container = styled.div<{ width?: string }>`
  width: ${({ width }) => width || '100%'};
  height: 100%;
  display: flex;
  align-items: center;
  padding: 5px;
  gap: 5px;
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
  background-color: ${({ theme }) => lighten(0.05, theme.colors.background)};
`;

export const Input = styled.input`
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.textBackground};
`;
